import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Breadcrumbs } from '../../../CommonComponents/OPL/Breadcrumbs/Breadcrumbs';
import { useNavigate } from '../../hooks/useNavigate';
import { useBreadcrumbsItems } from '../../hooks/useBreadcrumbsItems';
import { BrowserHeaderActions } from '../BrowserHeaderActions/BrowserHeaderActions';
import { HOME_PATH, ProviderType } from '../../DocumentVault.meta';
import { useDocumentVaultContext } from '../../context/useDocumentVaultContext';
import { useRouteParams } from '../../hooks/useRouteParams';

export const BrowserHeader = () => {
  const breadcrumbsItems = useBreadcrumbsItems();

  const navigate = useNavigate();

  const { setSelectedEntity, setForceYear } = useDocumentVaultContext();

  const { previousComponent } = useRouteParams();

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between" px="8" py="12">
      {!previousComponent && (
        <Breadcrumbs
          items={breadcrumbsItems}
          onNavigate={item => {
            setForceYear(null);

            if (item.path === HOME_PATH) {
              setSelectedEntity(null);

              return navigate({
                path: encodeURIComponent(item.path),
                providerType: ProviderType.All,
                filterableByYear: false,
              });
            }

            return navigate({
              path: encodeURIComponent(item.path),
            });
          }}
        />
      )}

      <Box display="flex" flexShrink={0} height={36} ml="24">
        <BrowserHeaderActions />
      </Box>
    </Box>
  );
};
